import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { modalController } from '@ionic/vue';

import ODNModalFile from '@m/odn-modal-file.vue';

/**
 * Android WebView has no built-in PDF renderer: a PDF loaded in an <iframe>
 * shows up blank. On Android, PDFs are downloaded to the cache directory and
 * handed over to the device's PDF viewer instead.
 */
const shouldOpenExternally = (file) =>
  Capacitor.getPlatform() === 'android' && file.mimetype === 'application/pdf';

const openExternally = async (file) => {
  const name = (file.originalname || `file-${Date.now()}.pdf`).replace(
    /[^\w.-]+/g,
    '_'
  );
  const { path } = await Filesystem.downloadFile({
    url: file.filename,
    path: `files/${name}`,
    directory: Directory.Cache,
    recursive: true,
  });
  await FileOpener.open({
    filePath: path,
    contentType: file.mimetype,
  });
};

/**
 * Open a file (image, video, PDF…) in the in-app viewer modal, or in an
 * external app when the WebView can't render it.
 */
export const openFile = async (file) => {
  if (shouldOpenExternally(file)) {
    try {
      return await openExternally(file);
    } catch (e) {
      console.error('Unable to open file externally', e);
      // Fall back to the modal, which offers a download button
    }
  }
  const modal = await modalController.create({
    component: ODNModalFile,
    componentProps: { file },
  });
  return modal.present();
};
